export default __webpack_public_path__ + "static/media/helpTabRightBranding.c686c655.svg";